import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { Preview as PreviewModule } from '@dev/ee-modules';
import { goBack as GoBack } from 'redux-first-history';
import { compose } from 'react-recompose';
import { Portal } from '@material-ui/core';
//actions in component
import { SetToastPortalWrapper } from '@/store/toast/actions';
import { TemplatePreviewStart } from '@/store/templateList/actions';

import { TemplatesPaths } from '../../../services/dictionaries/Paths';
import { PreviewProps } from './PreviewInterface';
import { ApplicationState as State } from '../../../store';

const mapState = (state: State, ownProps: PreviewProps): PreviewProps => ({
    ...ownProps,
    browser: state.browser,
    account: state.account,
    rawEditor: state.templateList,
    config: state.config,
});

interface DispatchProps {
    TemplatePreviewStart: (templateName: string, ispublic: boolean) => void;
    GoBack(): void;
    SetToastPortalWrapper: (isInsidePortal: boolean) => void;
}

const dispatchProps = {
    TemplatePreviewStart,
    GoBack,
    SetToastPortalWrapper,
};

type ExtendedProps = PreviewProps & DispatchProps;

class Preview extends Component<ExtendedProps> {
    public componentDidMount() {
        this.props.SetToastPortalWrapper(true);
    }

    public componentWillUnmount() {
        this.props.SetToastPortalWrapper(false);
    }

    public render(): JSX.Element {
        return (
            <Portal>
                <PreviewModule paths={TemplatesPaths} {...this.props} />
            </Portal>
        );
    }
}

export default compose(withTranslation(), connect<PreviewProps, DispatchProps>(mapState, dispatchProps))(Preview);
